export { default } from './DetectSettings';
export { default as reducer } from './DetectSettings.ducks';
export { default as sagas } from './DetectSettings.sagas';

import * as actions from './DetectSettings.ducks';
export { actions };
